import { memo } from 'react';

function ErrorIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="18"
			height="18"
			fill="none"
			viewBox="0 0 18 18"
		>
			<path
				fill="#FF6F73"
				fillRule="evenodd"
				d="M9 .753A8.334 8.334 0 019 17.42 8.334 8.334 0 019 .753zm1.91 5.245L9 7.908l-1.911-1.91L5.91 7.176l1.911 1.91-1.91 1.912 1.178 1.178 1.91-1.91 1.911 1.91 1.178-1.178-1.91-1.911 1.91-1.911-1.178-1.178z"
				clipRule="evenodd"
			></path>
		</svg>
	);
}

export default memo(ErrorIcon);
